exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.notes-modal .modal-dialog{width:580px}}@media (max-width:768px){.notes-modal .modal-dialog{position:absolute;width:100vw;height:100vh;margin:0}.notes-modal .modal-dialog .modal-content{border:none;box-shadow:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/appbundlesTable/notesModal/notesModal.css
// module id = 438
// module chunks = 0